<div class="logo-header-comp flex-row space-around w-100 pv-12">
  <div>
    <img src="assets/inwedio_white.svg" alt="" style="width: 106%" />
  </div>
</div>
